module.exports = {
  primaryShade1: "#ff9800",
  primaryShade2: "#ffcc80",
  primaryShade3: "#ffb74d",
  primaryShade4: "#ffa726",
  grey: "#9e9e9e",
  red: "#f44336",
  white: "#ffffff",
  black: "#000000",
  darkGrey: "#757575",
  secondaryShade: "#2196f3",
  secondaryShade1: "#bbdefb",
  secondaryShade6: "#1e88e5"
};
